/* eslint-disable no-unused-vars */
enum EStatusColors {
  SUCESSO = "#4C9C63",
  PROCESSANDO = "#1970A8",
  ERRO = "#CB3D3D",
  BLOQUEADA = "#E8BB16",
  PENDENTE = "#A1A1A1",
  ALERTA = "#E8BB16"
}

export default EStatusColors;
